<template>
    <div v-if="component.type === 'Header'" class="p-4" :class="previewBackground ? previewBackground : ''">
        <header-renderer :component="getComponentProperties(component.value)"
                         class="animate__animated"
                         :class="dynamicClasses(0)"></header-renderer>

        <header-renderer v-for="(child, index) in component.animation.children"
                         :key="'header-' + index"
                         :component="getComponentProperties(child.value)"
                         class="animate__animated"
                         :class="dynamicClasses(index + 1)">
        </header-renderer>
    </div>

</template>

<script>
    import HeaderRenderer from "./HeaderRenderer.vue";
    export default {
        name: 'AnimationContainer',
        components: {HeaderRenderer},
        props: ['component', 'previewBackground'],
        data () {
            return {
                model: webase.model,
                currentIndex: 0,
                timerId: null
            }
        },
        watch: {
            // whenever question changes, this function will run
            'component.animation.loop': function (newLoopValue, oldLoopValue) {
                if(newLoopValue) {
                    this.startLoop()
                }
                else {
                    this.stopLoop()
                }
            },

            'component.animation.delay': function (newDelayValue, oldDelayValue) {
                this.stopLoop()
                this.startLoop()
            }
        },
        computed: {
            listLength() {
                return this.component.animation.children.length + 1
            },
            delayInMilliSeconds() {

                if(isNaN(this.component.animation.delay)) {
                    return 1500
                }

                return Number(this.component.animation.delay) * 1000
            }
        },
        mounted () {
            if(this.component.animation.loop) {
                this.startLoop()
            }

        },
        beforeUnmount() {
            this.stopLoop()
        },
        methods: {
            dynamicClasses (index) {
                let displayClass = this.currentIndex % this.listLength === index ? 'd-block' : 'd-none'

                if(this.component.animation.value) {
                    return 'animate__' + this.component.animation.value + ' ' + displayClass
                }

                return displayClass
            },
            getComponentProperties (value) {
                let dynamicComponent = Object.assign({}, this.component)
                dynamicComponent.value = value
                return dynamicComponent
            },
            startLoop() {
                if(this.timerId !== null) {
                    return
                }

                this.timerId = setInterval( () => {
                    this.currentIndex++
                }, this.delayInMilliSeconds);
            },
            stopLoop() {
                if(this.timerId) {
                    clearInterval(this.timerId)
                }

                this.timerId = null
            }
        }
    }
</script>

<style>

</style>
